import type { PropsWithChildren } from 'react';

import { Popover } from '~/components/Popover';

import { IconButton } from '../IconButton';
import { KebabMenuItem } from './components/KebabMenuItem';

type KebabMenuProps = PropsWithChildren;

function KebabMenuComponent({ children }: KebabMenuProps) {
  return (
    <Popover content={children} stopPropagation triggerAsChild>
      <IconButton
        aria-label="open options menu"
        iconType="ellipsis-vertical"
        size="large"
      />
    </Popover>
  );
}

KebabMenuComponent.displayName = 'KebabMenu';

export const KebabMenu = Object.assign(KebabMenuComponent, {
  Item: KebabMenuItem,
});
